import React, { Component } from 'react';
import Player from '@vimeo/player';

class VideoResolucao extends Component {
    vimeoPlayer = null
    videoUpdated = false

    played = false
    watched50Percent = false
    watched70Percent = false
    ended = false

    constructor(props) {
        super(props)

        this.playEvent = this.playEvent.bind(this)
        this.timeUpdateEvent = this.timeUpdateEvent.bind(this)
        this.endedEvent = this.endedEvent.bind(this)
    }

    initVimeoVideo() {
        if (this.props.video && this.refs.videoResolucao) {
            // console.log(this.props)
            var options = {
                url: this.props.video,
                title: "Vídeo resolução",
                responsive: true
            };

            this.vimeoPlayer = new Player(this.refs.videoResolucao, options);
            this.vimeoPlayer.on('play', this.playEvent);
            this.vimeoPlayer.on('timeupdate', this.timeUpdateEvent);
            this.vimeoPlayer.on('ended', this.endedEvent);

            return true
        }

        return false
    }

    async resetVimeoVideo() {
        if (this.vimeoPlayer) await this.vimeoPlayer.destroy()

        while (this.refs.videoResolucao && this.refs.videoResolucao.firstChild) {
            this.refs.videoResolucao.removeChild(this.refs.videoResolucao.firstChild);
        }

        this.played = false
        this.watched50Percent = false
        this.watched70Percent = false
        this.ended = false
    }

    playEvent(data) {
        if (!this.played && this.props.events && this.props.events.onPlayed) {
            console.log('play', data);
            this.props.events.onPlayed()
        }
        this.played = true
    }

    timeUpdateEvent(data) {

        if (!this.watched50Percent && data.percent >= 0.5 && this.props.events && this.props.events.on50PercentWatched) {
            console.log('time is running 50%..', data)
            this.props.events.on50PercentWatched()
            this.watched50Percent = true
        }

        if (!this.watched70Percent && data.percent >= 0.7 && this.props.events && this.props.events.on70PercentWatched) {
            console.log('time is running 70%..', data)
            this.props.events.on70PercentWatched()
            this.watched70Percent = true
        }
    }

    endedEvent(data) {
        if (!this.ended && this.props.events && this.props.events.onEnded) {
            console.log('ended', data)
            this.props.events.onEnded()
            this.ended = true
        }
    }

    componentDidMount() {
        this.initVimeoVideo()
    }
    componentWillUnmount() {
        this.resetVimeoVideo()
    }
    async componentWillReceiveProps(nextProps) {
        if (nextProps.video !== this.props.video) {
            this.videoUpdated = true
            await this.resetVimeoVideo()
        }
    }
    componentDidUpdate() {
        if (this.videoUpdated) this.videoUpdated = !this.initVimeoVideo()
    }
    render() {
        return (<>
            <div className="edb-text-bold">Vídeo resolução</div>
            <div ref="videoResolucao" className="edb-margin-top edb-margin-bottom"></div>
        </>);
    }
}

export default VideoResolucao;